import {
  GET_HISTORY_LIST_ROUND_SUCCESS,
  GET_HISTORY_LIST_ROUND_FAIL,
  GET_HISTORY_LIST_CSR_SUCCESS,
  GET_HISTORY_LIST_CSR_FAIL,
  GET_RESULT_HISTORY_SUCCESS,
  GET_RESULT_HISTORY_FAIL,
  SEND_CHAT_MESSAGE_SUCCESS,
  SEND_CHAT_MESSAGE_FAIL,
  SEND_PARTICIPANT_CHAT_SUCCESS,
  SEND_PARTICIPANT_CHAT_FAIL,
  GET_PARTICIPANT_HISTORY_SUCCESS,
  GET_PARTICIPANT_HISTORY_FAIL,
} from "./actionTypes";

const INIT_STATE = {
  activitylogRounds: [],
  activitylogResults: [],
  participantHistory: [],
  activitylogCsr: [],
  participantChat: [],
  messages: [], // ✅ added to prevent undefined error
  error: null,
};

const activitylogReducer = (state = INIT_STATE, action) => {
  console.log("[Reducer Triggered] Type:", action.type);

  switch (action.type) {
    // ---- ROUND HISTORY ----
    case GET_HISTORY_LIST_ROUND_SUCCESS:
      // console.log("Data received in reducer:", action.payload);
      return {
        ...state,
        activitylogRounds: action.payload.results || [], // ✅ actual list
        count: action.payload.count || 0,
        next: action.payload.next || null,
        previous: action.payload.previous || null,
      };
    // Handle failure
    case GET_HISTORY_LIST_ROUND_FAIL:
      // console.log("Error received in reducer:", action.payload); // Log the error
      return {
        ...state,
        error: action.payload,
      };

    // ---- CSR HISTORY ----
    case GET_HISTORY_LIST_CSR_SUCCESS:
      return {
        ...state,
        activitylogCsr: action.payload.logs || [],
        participantChatMessages: action.payload.participant_chat_messages || [], // ✅ use correct key
        paymentChatMessages: action.payload.payment_chat_messages || [],
        error: null,
      };

    case GET_HISTORY_LIST_CSR_FAIL:
      console.error(
        "[Reducer] CSR History Fetch Failed. Error:",
        action.payload
      );
      return {
        ...state,
        error: action.payload,
      };
    // ---- RESULT HISTORY ----
    case GET_RESULT_HISTORY_SUCCESS:
      console.log("[Reducer] Result History Data:", action.payload);
      return {
        ...state,
        activitylogResults: action.payload?.data || action.payload || [],
        error: null,
      };

    case GET_RESULT_HISTORY_FAIL:
      console.error("[Reducer] Result History Error:", action.payload);
      return { ...state, error: action.payload };

    case SEND_CHAT_MESSAGE_SUCCESS:
      console.log("[Reducer] Message Sent:", action.payload);
      return {
        ...state,
        messages: [...(state.messages || []), action.payload],
        error: null,
      };

    case SEND_CHAT_MESSAGE_FAIL:
      console.error("[Reducer] Message Send Error:", action.payload);
      return { ...state, error: action.payload };
    ////////////////////////
    case SEND_PARTICIPANT_CHAT_SUCCESS:
      console.log("[Reducer] Message Sent:", action.payload);
      return {
        ...state,
        participantChat: [...(state.participantChat || []), action.payload],
        error: null,
      };
    // ---- CSR HISTORY ----
    case GET_PARTICIPANT_HISTORY_SUCCESS:
      return {
        ...state,
        participantHistory: action.payload.logs || [],
        participantChatMessages: action.payload.participant_chat_messages || [], // ✅ use correct key
        paymentChatMessages: action.payload.payment_chat_messages || [],
        error: null,
      };

    case GET_PARTICIPANT_HISTORY_FAIL:
      console.error(
        "[Reducer] CSR History Fetch Failed. Error:",
        action.payload
      );
      return {
        ...state,
        error: action.payload,
      };
    case SEND_PARTICIPANT_CHAT_FAIL:
      console.error("[Reducer] Message Send Error:", action.payload);
      return { ...state, error: action.payload };
    default:
      return state;
  }
};

export default activitylogReducer;
